export type IconName =
  | 'home'
  | 'search'
  | 'queue'
  | 'music'
  | 'volume'
  | 'status'
  | 'play'
  | 'pause'
  | 'previous'
  | 'next'
  | 'repeat'
  | 'shuffle'
  | 'stop'
  | 'autoplay'
  | 'import'
  | 'lock'
  | 'chevron'

export function Icon({ name, size = 22 }: { name: IconName; size?: number }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  }

  if (name === 'home')
    return (
      <svg {...common}>
        <path d="m3 11 9-8 9 8" />
        <path d="M5 10v10h14V10M9 20v-6h6v6" />
      </svg>
    )
  if (name === 'search')
    return (
      <svg {...common}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-4-4" />
      </svg>
    )
  if (name === 'queue')
    return (
      <svg {...common}>
        <path d="M4 6h11M4 12h11M4 18h7" />
        <path d="m17 15 4 3-4 3z" fill="currentColor" stroke="none" />
      </svg>
    )
  if (name === 'volume')
    return (
      <svg {...common}>
        <path d="M11 5 6 9H3v6h3l5 4zM15 9a5 5 0 0 1 0 6M18 6a9 9 0 0 1 0 12" />
      </svg>
    )
  if (name === 'status')
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12h8M12 8v8" />
      </svg>
    )
  if (name === 'play')
    return (
      <svg {...common}>
        <path d="m8 5 11 7-11 7z" fill="currentColor" stroke="none" />
      </svg>
    )
  if (name === 'pause')
    return (
      <svg {...common}>
        <rect x="6.5" y="5" width="4" height="14" rx="1.4" fill="currentColor" stroke="none" />
        <rect x="13.5" y="5" width="4" height="14" rx="1.4" fill="currentColor" stroke="none" />
      </svg>
    )
  if (name === 'previous' || name === 'next')
    return (
      <svg {...common}>
        {name === 'previous' ? (
          <>
            <path d="M18 6 9 12l9 6z" fill="currentColor" stroke="none" />
            <path d="M6 6v12" />
          </>
        ) : (
          <>
            <path d="m6 6 9 6-9 6z" fill="currentColor" stroke="none" />
            <path d="M18 6v12" />
          </>
        )}
      </svg>
    )
  if (name === 'repeat')
    return (
      <svg {...common}>
        <path d="m17 2 3 3-3 3M3 11V9a4 4 0 0 1 4-4h13M7 22l-3-3 3-3M21 13v2a4 4 0 0 1-4 4H4" />
      </svg>
    )
  if (name === 'shuffle')
    return (
      <svg {...common}>
        <path d="M16 3h5v5M4 20 21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />
      </svg>
    )
  if (name === 'stop')
    return (
      <svg {...common}>
        <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" stroke="none" />
      </svg>
    )
  if (name === 'autoplay')
    return (
      <svg {...common}>
        <path d="M5.5 8.5A7.5 7.5 0 0 1 18 6l2 2M18.5 15.5A7.5 7.5 0 0 1 6 18l-2-2" />
        <path d="M20 4v4h-4M4 20v-4h4" />
        <path d="m10 9 5 3-5 3z" fill="currentColor" stroke="none" />
      </svg>
    )
  if (name === 'import')
    return (
      <svg {...common}>
        <path d="M12 3v12M7.5 10.5 12 15l4.5-4.5M5 20h14" />
      </svg>
    )
  if (name === 'lock')
    return (
      <svg {...common}>
        <rect x="5" y="10" width="14" height="10" rx="3" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
      </svg>
    )
  if (name === 'chevron')
    return (
      <svg {...common}>
        <path d="m7 9.5 5 5 5-5" />
      </svg>
    )
  return (
    <svg {...common}>
      <path d="M9 18V5l11-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="17" cy="16" r="3" />
    </svg>
  )
}

export function BrandWave({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`brand-wave ${compact ? 'compact' : ''}`} aria-hidden="true">
      <i />
      <i />
      <i />
      <i />
      <i />
    </span>
  )
}
